import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['One manual per level, bought separately', 'One plan per lesson, written for good wind', 'Drills scattered across PDFs, forums and old binders', 'No shore or rainy-day version of the lesson', 'You still build the camp week and the season alone'];
const withIt = ['Beginners to race training, juniors to adults, in one pack', 'Every lesson in Light Air, Right Air and Wrong Air', '131 Lesson Cards in the same one-page format', 'Dock, shore and indoor versions with the same goal', 'Five-day camp plans and eight-week season templates'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-290" data-mp="2d8sqg2hu7k84">
      <div className="mx-auto max-w-4xl px-5 py-16 sm:py-20" data-id="element-291" data-mp="2d6zjsn785004">
        <div className="text-center" data-id="element-292" data-mp="30y50f4kznwbh">
          <p className="text-sm font-semibold text-teal-deep" data-id="element-293" data-mp="30x3icg5k29k9">Why this isn&apos;t another drill book</p>
          <h2 id="vs-heading" className="mt-3 font-display text-3xl text-navy sm:text-5xl" data-id="element-294" data-mp="35r7sf8a4axpk">
            Drill books vs <span className="wash-text" data-id="element-295" data-mp="1td0gepi1zbl8">lessons for every wind</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-navy-soft" data-id="element-296" data-mp="1oi3a3qc5rgc1">
            Most material for sailing instructors is an official manual for
            one level or a free bank of drills. Useful, but the drill was never
            the hard part. Knowing what to run with this group, today, when the
            wind doesn&apos;t cooperate, was.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-3xl shadow-card" data-id="element-297" data-mp="2m3sczo316293">
          <div className="bg-paper px-3.5 py-4 sm:p-6" data-id="element-298" data-mp="2h4xqab1xztjp">
            <h3 className="font-display text-base text-navy-muted sm:text-xl" data-id="element-299" data-mp="2h5gz929m77ll">
              Manuals and free drill banks
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-300" data-mp="mqwll9jpocbp">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-navy-soft sm:text-sm" data-id="element-301" data-mp="mt971wooh4ti">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-rose-soft" data-id="element-302" data-mp="2rrqumta5wshi">
                    <XIcon className="h-2.5 w-2.5 text-rose-deep" aria-hidden="true" data-id="element-303" data-mp="2vssv1dftfal2" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-teal-soft px-3.5 py-4 sm:p-6" data-id="element-304" data-mp="35qyu7na8m2m8">
            <h3 className="font-display text-base text-teal-deep sm:text-xl" data-id="element-305" data-mp="3aqv23xm22e72">
              Sailing Lesson Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-306" data-mp="3fiwah8g3rkrt">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-semibold leading-snug text-navy sm:text-sm" data-id="element-307" data-mp="3jjojc0l2bnnk">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white" data-id="element-308" data-mp="3ok2tppa4z9or">
                    <CheckIcon className="h-2.5 w-2.5 text-teal-deep" aria-hidden="true" data-id="element-309" data-mp="3tfi6edweqzjl" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}